import classNames from 'classnames'
import styles from './TaxReceiptHint.module.css'
import { DefaultLink, LinkItem } from '../../shared'
import { LayoutStack } from '../../../components/layouts'
import { headlessLinkProps } from '../../../components/TextLink'
import { useEffect, useState } from 'react'

function displayTaxReceiptHint() {
  const now = new Date()
  return now.getMonth() > 8 || now.getMonth() < 1 // JS months are 0-indexed (9 = October, 0 = January)
}

function taxReceiptHintRelevantYear() {
  const now = new Date()
  let year = now.getFullYear()
  if (now.getMonth() < 9) {
    // If before October
    year -= 1
  }
  return year
}

function TaxReceiptHint({
  children,
  href,
  label,
  Link = DefaultLink,
}: {
  children: string
  label: string
  href: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Link?: React.FC<any>
}) {
  const [showHint, setShowHint] = useState(false)
  const [year, setYear] = useState(0)
  const { className } = headlessLinkProps({ kind: 'secondary' })
  useEffect(() => {
    setShowHint(displayTaxReceiptHint())
    setYear(taxReceiptHintRelevantYear())
  }, [])
  if (!showHint) return null
  return (
    <LayoutStack space="none" className={styles.taxReceiptHint}>
      <div className={styles.content}>
        <p>
          {children.replace('0000', year.toString()).replace('0001', (year + 1).toString())}&ensp;
          <LinkItem Link={Link} href={href} className={classNames(className, styles.learnMoreLink)}>
            {label}
          </LinkItem>
        </p>
      </div>
    </LayoutStack>
  )
}

export default TaxReceiptHint
